import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: ['options'],
  mounted () {
    this.renderChart(this.chartData, {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        xAxes: [{
          display: true,
          scaleLabel: {
            display: true,
            labelString: '날짜'
          },
          gridLines: {
            display: true // 수치마다 세로선 유무
          }
        }],
        yAxes: [{
          display: true,
          ticks: {
            suggestedMin: 0
          },
          scaleLabel: {
            display: true,
            labelString: '온도'
          }
        }]
      },
      plugins: {
        datalabels: {
          display: false
        }
      }
    })
    const HTML = this.generateLegend()
    this.$emit('generated', HTML)
  }
}



// WEBPACK FOOTER //
// ./src/util/LineChart.js